<template>
  <VueFinalModal
    modal-id="car-comparison-mobile-overlay"
    content-class="car-comparison-mobile-overlay"
    :lock-scroll="false"
    :hide-overlay="false"
    swipe-to-close="none"
    :click-to-close="true"
    background="non-interactive"
    content-transition="vfm-fade"
    overlay-transition="vfm-fade"
    @update:model-value="(val: boolean) => hideOverlay()"
  >
    <div class="car-comparison-mobile-overlay__container" @click="hideOverlay">
      <h3 class="car-comparison-mobile-overlay__text">Swipe left to view more cars</h3>
      <button class="car-comparison-mobile-overlay__button">Ok</button>
    </div>
  </VueFinalModal>
</template>

<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal';
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';
import { storeToRefs } from 'pinia';

const comparisonStore = useCarComparisonStore();
const { userHasAcceptedMobileInfoOverlay } = storeToRefs(comparisonStore);

const emit = defineEmits<{
  (e: 'update:modelValue', modelValue: boolean): void;
}>();

function hideOverlay() {
  emit('update:modelValue', false);
  userHasAcceptedMobileInfoOverlay.value = true;
}
</script>

<style lang="scss" scoped>
.car-comparison-mobile-overlay {
  &__container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: end;
    height: 100vh;
    padding-right: 1.5rem;
  }

  &__text {
    direction: rtl;
    max-width: 10rem;
  }

  &__text,
  &__button {
    color: #fff;
    font-family: 'Segoe-ui', $arial-regular-font;
    font-weight: 100;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  &__button {
    background: transparent;
    border: 1px solid #fff;
    padding: 0.5rem 2.25rem;
    border-radius: 0.25rem;
  }
}
</style>
